import apiClient from '../utils/apiClient';

class PreferencesService {
  
  // Récupérer les préférences utilisateur
  async getPreferences() {
    try {
      const response = await apiClient.get('/user/preferences');
      return response.data;
    } catch (error) {
      console.error('Erreur récupération préférences:', error);
      throw error;
    }
  }

  // Sauvegarder les préférences utilisateur
  async savePreferences(preferences) {
    try {
      const response = await apiClient.put('/user/preferences', preferences);
      return response.data;
    } catch (error) {
      console.error('Erreur sauvegarde préférences:', error);
      throw error;
    }
  }

  // Réinitialiser les préférences
  async resetPreferences() {
    try {
      const response = await apiClient.post('/user/preferences/reset');
      return response.data;
    } catch (error) {
      console.error('Erreur réinitialisation préférences:', error);
      throw error;
    }
  }

  // Sauvegarder uniquement la langue
  async saveLanguagePreference(language) {
    try {
      const response = await apiClient.put('/user/preferences', { language });
      return response.data;
    } catch (error) {
      console.error('Erreur sauvegarde langue:', error);
      throw error;
    }
  }

  // Sauvegarder uniquement le thème
  async saveThemePreference(theme) {
    try {
      const response = await apiClient.put('/user/preferences', { theme });
      return response.data;
    } catch (error) {
      console.error('Erreur sauvegarde thème:', error);
      throw error;
    }
  }

  // Sauvegarder uniquement les notifications
  async saveNotificationPreferences(notifications) {
    try {
      const response = await apiClient.put('/user/preferences', { notifications });
      return response.data;
    } catch (error) {
      console.error('Erreur sauvegarde notifications:', error);
      throw error;
    }
  }
}

export default new PreferencesService();
